import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";

import { secondAxios } from "../../../../../../../api/axios";
import ColoredSnackbar from "../../../../../../../components/ColoredSnakebar";
import { AddToMrqTable } from "./table/AddToMrqTable";

export default function AddToNewMrqAction({
  plant,
  selectedRowsData,
  disabled,
}) {
  const [open, setOpen] = useState(false);

  const [mrqMaterials, setMrqMaterials] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [mrqDetails, setMrqDetails] = useState({});

  const handleConfirm = async () => {
    const createdMrq = {
      ...mrqDetails,
      plantName: plant.name,

      mrqMaterials: mrqMaterials.map((m) => {
        return {
          ...m,
        };
      }),
    };
    console.log("Confirm Revise MRQ", createdMrq);

    // const { data } = await secondAxios.post("/mrq/", createdMrq);
    // console.log("res", data);

    // if (data?.mrq?.id) {
    //   setOpen(false);
    //   setSnackbar({
    //     open: true,
    //     message: "MRQ revised successfully!",
    //     severity: "success",
    //   });
    // } else {
    //   setSnackbar({
    //     open: true,
    //     message: "Failed to revise MRQ. Please try again.",
    //     severity: "error",
    //   });
    // }
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddBoxIcon />}
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        Add to MRQ
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Add to MRQ</DialogTitle>

        <DialogContent>
          <AddToMrqTable
            plant={plant}
            mrqDetails={mrqDetails}
            data={selectedRowsData}
            mrqMaterials={mrqMaterials}
            setMrqMaterials={setMrqMaterials}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>

          <Button variant="contained" onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <ColoredSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </>
  );
}
